import React from "react";
import classNames from "classnames";
import Ripple from "../Ripple";
import { ListItemProps } from "./PropsType";

export default function ListItem(props: ListItemProps) {
  const {
    avatarRight,
    children,
    className,
    disableRipple,
    index,
    onClick,
    prefixCls = "bm-List-item",
    ...other
  } = props;
  const styleClass = classNames(
    prefixCls,
    avatarRight ? `${prefixCls}-avatar-right` : "",
    className
  );

  const handleClick = (event: any) => {
    event.stopPropagation();
    if (props.onClick) {
      (props.onClick as (event: any) => void)(event);
    }
  };
  return (
    <li className={styleClass} onClick={handleClick} {...other}>
      <div className={`${prefixCls}-btn`}>
        {children}
        {!disableRipple ? <Ripple /> : null}
      </div>
    </li>
  );
}
